import { render, staticRenderFns } from "./Trailer.vue?vue&type=template&id=a4494498"
import script from "./Trailer.vue?vue&type=script&lang=js"
export * from "./Trailer.vue?vue&type=script&lang=js"
import style0 from "./Trailer.vue?vue&type=style&index=0&id=a4494498&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports